import React from 'react';
import { Skeleton } from '../../common/Skeleton';

const ROWS = 4;

/**
 * Ocupa el sitio de .results-book-item mientras responde /books_list. Reusa las
 * mismas clases que la fila real para que la geometria coincida y la lista no
 * salte al llegar los resultados.
 */
export const SearchResultsSkeleton: React.FC = () => (
  <>
    {Array.from({ length: ROWS }).map((_, i) => (
      <div key={i} className="results-book-item results-book-item-stock al-skeleton-row" aria-hidden="true">
        <Skeleton width="85%" height="0.9rem" />
        <Skeleton width="45%" height="0.6rem" />
        <div className="results-book-info-row">
          <Skeleton width="8rem" height="0.6rem" />
          <Skeleton width="3.5rem" height="0.8rem" />
        </div>
      </div>
    ))}
  </>
);
